import { mapVoucherTicketPriceToTicketDetails } from '../../../sales-data/mappers/ticket-details';
import { getTicketPricesForVoucherType } from '../../../sales-data/selectors/tickets/get-ticket-prices-for-voucher-type';
import { attemptToAddOrderTicketForShowtime } from './attempt-to-add-order-ticket-for-showtime';
/**
 * Attempts to add a ticket for a voucher in the order.
 *
 * We can only do this when:
 * 1. There is only one [[TicketPrice]] for the voucher.
 * 2. (Seat first ordering) We have enough remaining tickets to allocate in the ticket type's area category.
 *
 * @returns `true` if the ticket was added or `false` if the ticket could not be added.
 */
export const attemptToAddOrderTicketForVoucher = (showtimeId, voucher) => {
    const ticketPrices = getTicketPricesForVoucherType(showtimeId, voucher.voucherTypeCode);
    if (ticketPrices.length !== 1)
        return false;
    const ticket = mapVoucherTicketPriceToTicketDetails(ticketPrices[0], voucher.id);
    return attemptToAddOrderTicketForShowtime(showtimeId, ticket);
};
